var exports = {
  "o5": "x31de4314--ac0fcc--content-wrapper",
  "HE": "x31de4314--ac0fcc--button-wrapper",
  "aw": "x31de4314--ac0fcc--semi-transparent",
  "Sl": "x31de4314--ac0fcc--image",
  "W4": "x31de4314--ac0fcc--text-wrapper",
};

module.exports = exports;
